import { AnimatedSprite, Application } from "pixi.js";
import { Character, Coordinate } from "../pixiApplication";
import { boyademlad } from "../spritesheets/boyademlad";
import { boyademlad2 } from "../spritesheets/boyademlad2";
import { boyademlad3 } from "../spritesheets/boyademlad3";
import { boyademladswipe } from "../spritesheets/boyademladswipe";
import { boyademladswipe2 } from "../spritesheets/boyademladswipe2";
import { boyademladsprite3 } from "../spritesheets/boyademladsprite3";
import { loadSound, playSound } from "../audio";

export class Player implements Character {
  up: boolean;
  down: boolean;
  left: boolean;
  right: boolean;
  controllerActive: boolean;
  sprite: AnimatedSprite;
  doSwipe: boolean;
  swipe: (position: Coordinate) => void;
  id = "lad";

  animations: {
    down: AnimatedSprite;
    downSwipe: AnimatedSprite;
    leftRight: AnimatedSprite;
    leftRightSwipe: AnimatedSprite;
    up: AnimatedSprite;
    upSwipe: AnimatedSprite;
  } = {
    down: undefined,
    downSwipe: undefined,
    leftRight: undefined,
    leftRightSwipe: undefined,
    up: undefined,
    upSwipe: undefined,
  };

  position: {
    x: number;
    y: number;
  };

  async initSprites() {
    this.animations.leftRight = await boyademlad();
    this.animations.leftRight.animationSpeed = 0.5;

    this.animations.leftRightSwipe = await boyademladswipe();
    this.animations.leftRightSwipe.animationSpeed = 0.33;
    this.animations.leftRightSwipe.loop = false;

    this.animations.down = await boyademlad2();
    this.animations.down.animationSpeed = 0.5;

    this.animations.downSwipe = await boyademladswipe2();
    this.animations.downSwipe.animationSpeed = 0.33;
    this.animations.downSwipe.loop = false;

    this.animations.up = await boyademlad3();
    this.animations.down.animationSpeed = 0.5;

    this.animations.upSwipe = await boyademladsprite3();
    this.animations.upSwipe.animationSpeed = 0.33;
    this.animations.upSwipe.loop = false;

    this.sprite = this.animations.leftRight;
  }

  constructor(app: Application, swipe: (position: Coordinate) => void) {
    this.swipe = swipe;
    this.up = false;
    this.down = false;
    this.left = false;
    this.right = false;
    this.controllerActive = false;

    window.onkeydown = (e) => {
      const clear = () => {
        this.up = false;
        this.down = false;
        this.left = false;
        this.right = false;
      };

      switch (e.key) {
        case "ArrowUp":
        case "w":
          clear();
          this.up = true;
          break;
        case "ArrowDown":
        case "s":
          clear();
          this.down = true;
          break;
        case "ArrowLeft":
        case "a":
          clear();
          this.left = true;
          break;
        case "ArrowRight":
        case "d":
          clear();
          this.right = true;
          break;
        case " ":
          this.doSwipe = true;
          break;
      }
    };

    window.onkeyup = (e) => {
      switch (e.key) {
        case "ArrowUp":
        case "w":
          this.up = false;
          break;
        case "ArrowDown":
        case "s":
          this.down = false;
          break;
        case "ArrowLeft":
        case "a":
          this.left = false;
          break;
        case "ArrowRight":
        case "d":
          this.right = false;
          break;
      }
    };

    app.ticker.add(() => {
      navigator.getGamepads().forEach((pad) => {
        if (pad) {
          if (pad.axes[0] === 0 && pad.axes[1] === 0) {
            if (this.controllerActive) {
              this.up = false;
              this.down = false;
              this.left = false;
              this.right = false;
            }
            this.controllerActive = false;
          } else {
            if (pad.axes[0] > 0.3) {
              this.left = false;
              this.right = true;
              this.controllerActive = true;
            } else if (pad.axes[0] < -0.3) {
              this.left = true;
              this.right = false;
              this.controllerActive = true;
            } else {
              this.left = false;
              this.right = false;
            }

            if (pad.axes[1] > 0.3) {
              this.up = false;
              this.down = true;
              this.controllerActive = true;
            } else if (pad.axes[1] < -0.3) {
              this.up = true;
              this.down = false;
              this.controllerActive = true;
            } else {
              this.up = false;
              this.down = false;
            }

            if (pad.buttons[0].pressed) {
              this.doSwipe = true;
            }
          }
        }
      });
    });
  }

  tick() {
    if (this.doSwipe) {
      if (
        !this.animations.leftRightSwipe.playing &&
        !this.animations.upSwipe.playing &&
        !this.animations.downSwipe.playing
      ) {
        const swipePosition = { x: this.position.x, y: this.position.y };
        const swipe = loadSound("swipe");
        playSound(swipe, "GAME");
        const currentSprite = this.sprite;
        if (this.sprite.uid === this.animations.leftRight.uid) {
          this.animations.leftRightSwipe.scale.x = this.sprite.scale.x;
          this.sprite = this.animations.leftRightSwipe;
          if (this.sprite.scale.x < 0) {
            swipePosition.x--;
          } else {
            swipePosition.x++;
          }
        } else if (this.sprite.uid === this.animations.down.uid) {
          this.sprite = this.animations.downSwipe;
          swipePosition.y++;
        } else if (this.sprite.uid === this.animations.up.uid) {
          this.sprite = this.animations.upSwipe;
          swipePosition.y--;
        }
        this.sprite.visible = true;
        this.sprite.gotoAndPlay(0);
        this.sprite.onFrameChange = (currentFrame) => {
          if (currentFrame === 4) {
            this.swipe(swipePosition);
          }
        };
        this.sprite.onComplete = () => {
          this.doSwipe = false;
          this.sprite.visible = false;
          this.sprite = currentSprite;
        };
      }
    } else if (this.up) {
      this.animations.up.gotoAndPlay(0);
      this.sprite = this.animations.up;
      this.position.y--;
    } else if (this.down) {
      this.animations.down.gotoAndPlay(0);
      this.sprite = this.animations.down;
      this.position.y++;
    } else if (this.left) {
      this.animations.leftRight.gotoAndPlay(0);
      this.animations.leftRight.scale.x = -2;
      this.sprite = this.animations.leftRight;
      this.position.x--;
    } else if (this.right) {
      this.animations.leftRight.gotoAndPlay(0);
      this.animations.leftRight.scale.x = 2;
      this.sprite = this.animations.leftRight;
      this.position.x++;
    } else {
      this.sprite.gotoAndStop(0);
    }
    this.sprite.anchor = 0.5;
  }

  catch() {
    console.error("uh-oh");
  }

  release() {
    console.error("uh-oh");
  }
}
